import {
	confirmTableModalData,
	getTableModalData,
	getTableModalPagination,
	selectAllTableModalData,
	selectTableModalData
} from 'actions'
import CrudFilters from 'components/abmUtils/CrudFilters'
import TableWithSelection from 'components/abmUtils/TableWithSelection'
import { CrudFiltersProps } from 'models/CrudFilters'
import { ICrudFieldStructure } from 'models/CrudInterface'
import {
	IConfirmTableModalData,
	IConfirmTableModalDataResponse,
	IGetTableModalData,
	IGetTableModalDataResponse,
	IGetTableModalPagination,
	ISelectAllTableModalData,
	ISelectTableModalData,
	ITableModalProps,
	ITableModalState
} from 'models/TableModal'
import { ITableWithSelectionFields } from 'models/TableWithSelection'
import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import { TransProps, withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'underscore'
import CommonModal from '../commonModal'

interface IReduxProps {
	getTableModalData: (params: IGetTableModalData) => void
	getTableModalPagination: (params: IGetTableModalPagination) => void
	selectTableModalData: (params: ISelectTableModalData) => void
	selectAllTableModalData: (params: ISelectAllTableModalData) => void
	confirmTableModalData: (params: IConfirmTableModalData) => void
	tableModalValues: IGetTableModalDataResponse
	tableModalAmount: IConfirmTableModalDataResponse
}

class TableModal extends Component<
	ITableModalProps & IReduxProps & TransProps & WithTranslation,
	ITableModalState
> {
	constructor(
		props: ITableModalProps & IReduxProps & TransProps & WithTranslation
	) {
		super(props)
		this.state = {
			searchParams: {
				idOperacion: props.idOperacion.toString(),
				cod_lista: props.listCode,
				filtro: '',
				page_number: 1,
				page_size: 10
			},
			selectedRows: []
		}
	}

	componentDidMount(): void {
		const { getTableModalData, idOperacion, listCode } = this.props

		getTableModalData({
			idOperacion: idOperacion,
			cod_lista: listCode
		})
	}

	componentDidUpdate(
		prevProps: Readonly<ITableModalProps & IReduxProps>,
		prevState: Readonly<ITableModalState>
	): void {
		const { getTableModalPagination, tableModalValues } = this.props
		const { searchParams } = this.state

		if (tableModalValues && tableModalValues !== prevProps.tableModalValues) {
			const newRows: string[] = []
			_.forEach(tableModalValues.lista, (item) => {
				if (item.sel === 1) newRows.push(item.codigo)
			})

			this.setState({
				selectedRows: newRows
			})
		}

		if (searchParams !== prevState.searchParams) {
			getTableModalPagination(searchParams)
		}
	}

	handleSearch = (value: any) => {
		const { searchParams } = this.state

		this.setState({ searchParams: { ...searchParams, filtro: value.busqueda } })
	}

	handleChangeTable = (type: string, pagination: any, value: any) => {
		if (type === 'pagination') {
			this.handlePaginationChange(pagination.page, pagination.sizePerPage)
		}
	}

	handleSelection = (selectedRow: string, table: string, action: string) => {
		const { tableModalValues, selectTableModalData } = this.props
		const { selectedRows, searchParams } = this.state

		let newRows: Array<string> = [...selectedRows]

		if (action === 'add') {
			newRows.push(selectedRow)
		} else if (action === 'delete') {
			newRows = newRows?.filter((row) => row !== selectedRow)
		}

		selectTableModalData({
			idOperacion: Number(searchParams.idOperacion),
			cod_lista: searchParams.cod_lista,
			lista: _.map(tableModalValues.lista, (item) => {
				return {
					nro: item.nro,
					codigo: item.codigo,
					descrip: item.descrip,
					sel: Number(_.any(newRows, (row) => item.codigo === row))
				}
			})
		})
	}

	handleSelectAll = (action: string) => {
		const { selectAllTableModalData } = this.props
		const { searchParams } = this.state

		selectAllTableModalData({
			idOperacion: Number(searchParams.idOperacion),
			cod_lista: searchParams.cod_lista,
			sel: action === 'add' ? 1 : 0
		})
	}

	handlePaginationChange = (page_number: number, page_size: number) => {
		const { searchParams } = this.state

		this.setState({
			searchParams: {
				...searchParams,
				page_number: page_number,
				page_size: page_size
			}
		})
	}

	handleExitModal = () => {
		const { handleCloseModal } = this.props
		const { searchParams } = this.state

		this.setState({
			searchParams: {
				...searchParams,
				filtro: '',
				page_number: 1,
				page_size: 10
			}
		})

		handleCloseModal()
	}

	renderSearchModal = () => {
		const { tableModalValues, modalTitle, t } = this.props
		const { selectedRows } = this.state

		const fields: Array<ICrudFieldStructure> = [
			{
				idCampo: 'busqueda',
				descrip: 'busqueda',
				label: t('global.search'),
				mascara: '',
				editable: true,
				visible: 1,
				requerido: false,
				valid: '',
				agrupador: 'campos'
			}
		]

		const tableFields: Array<ICrudFieldStructure> = [
			{
				idCampo: 'codigo',
				descrip: 'busqueda',
				label: t('global.code'),
				mascara: '',
				editable: false,
				visible: 1,
				requerido: false,
				valid: '',
				agrupador: 'campos'
			},
			{
				idCampo: 'descrip',
				descrip: 'busqueda',
				label: t('global.description'),
				mascara: '',
				editable: false,
				visible: 1,
				requerido: false,
				valid: '',
				agrupador: 'campos'
			}
		]

		const filterProps: CrudFiltersProps = {
			fields: fields,
			handleSearch: this.handleSearch,
			hideSearch: false,
			hideNew: true,
			hideBack: true,
			customButtons: [
				{
					id: 'confirm_button',
					valueButton: t('global.confirm'),
					onClick: this.handleExitModal,
					showButton: true
				}
			]
		}

		const tableProps: ITableWithSelectionFields = {
			checkBox: true,
			disableForm: false,
			fields: tableModalValues?.lista ?? [],
			handleSelectAll: this.handleSelectAll,
			keyfield: 'codigo',
			label: modalTitle,
			paginationOption: tableModalValues ?? null,
			handleChangeTable: this.handleChangeTable,
			setSelection: this.handleSelection,
			selected: selectedRows,
			tableFields: tableFields,
			hideScrollX: true
		}

		return (
			<>
				<CrudFilters {...filterProps} />
				<TableWithSelection {...tableProps} />
			</>
		)
	}

	render() {
		const { showModal, modalTitle } = this.props

		const propsSearchModal = {
			showModal: showModal,
			handleCloseModal: this.handleExitModal,
			modalTitle: modalTitle,
			modalBody: showModal ? this.renderSearchModal() : <></>,
			buttons: false,
			sizeModal: 'xl'
		}

		return <Col>{showModal && <CommonModal {...propsSearchModal} />}</Col>
	}
}

const mapStateToProps = ({ tableModal }: any) => {
	const { tableModalValues, tableModalAmount } = tableModal
	return {
		tableModalValues,
		tableModalAmount
	}
}

const connectForm = connect(mapStateToProps, {
	getTableModalData,
	getTableModalPagination,
	selectTableModalData,
	selectAllTableModalData,
	confirmTableModalData
})(TableModal)

export default withTranslation()(connectForm)
